<template>
    <div class="page-sidebar">
        <div class="page-sidebar-box">
            <el-menu router :default-active="setMenuActive()" active-text-color="#ffffff" unique-opened>
                <template v-for="item in menus">
                    <template v-if="item.child && item.child.length > 0">
                        <el-submenu :index="`${item.id}`" :key="item.id">
                            <div slot="title">
                                <i class="nav-icon"></i>
                                {{ item.name }}
                                <template v-if="type == 1">
                                    <span v-if="$store.getters.userState == 1" class="icon-tip">未认证</span>
                                    <span v-if="$store.getters.userState == 2" class="icon-tip">未签署</span>
                                    <span v-if="$store.getters.userState == 3 || $store.getters.userState == 4"
                                        class="icon-tip">未付费</span>
                                    <span v-if="$store.getters.userState == 5" class="icon-tip">已到期</span>
                                </template>
                            </div>
                            <template v-for="subItem in item.child">
                                <el-menu-item v-if="subItem.link" :key="subItem.id" :index="`${subItem.link || ''}`">
                                    <i class="menu-icon"></i>
                                    {{ subItem.name }}
                                </el-menu-item>
                            </template>
                        </el-submenu>
                    </template>
                    <template v-else>
                        <el-menu-item :index="`${item.link}`" :key="item.id">
                            <div slot="title">
                                <i class="menu-icon"></i>
                                {{ item.name }}
                            </div>
                        </el-menu-item>
                    </template>
                </template>
            </el-menu>
        </div>
    </div>
</template>
<script>
import logo from '@/assets/img/logo.png';
export default {
    props: {
        type: {
            type: Number,
            default: 1 // 菜单类型  主菜单：1（默认） 帮助菜单：2
        },
        menuList: {
            type: Array,
            default: () => null
        }
    },
    data() {
        return {};
    },
    computed: {
        isPoint() {
            const { fddSignStatus, vip } = this.$store.state.verify || {};
            if (fddSignStatus !== 1) return true;
            if (vip && vip.isPaid !== 1) return true;
            return false;
        },
        isLogoPoint() {
            const { cpLogo } = this.$store.state.userInfo || {};
            return cpLogo ? false : true;
        },
        logo() {
            return logo || this.$store.state.config._platformCpHeadPic;
        },
        vip() {
            return this.$store.state.verify && this.$store.state.verify.vip;
        },
        isManager() {
            return this.$store.state.userInfo && this.$store.state.userInfo.isManager;
        },
        menus() {
            // const permissions = this.$store.state.permissions || [];
            // const _permissions = this.treePermissions(permissions);
            const _permissions = [
                {
                    id: 1,
                    link: '/manage/dashboard',
                    name: '我的工作台'
                },
                {
                    id: 2,
                    link: '/manage/album/list',
                    name: '专辑管理'
                }
            ];

            const _accountData = {
                id: 346,
                link: '',
                name: '个人中心',
                child: [
                    {
                        id: 400,
                        link: '/manage/mainInfo',
                        name: '基本信息'
                    },
                    {
                        id: 407,
                        link: '/manage/accountManage',
                        name: '账号管理'
                    },
                    {
                        id: 409,
                        link: '/manage/bankInfo',
                        name: '收款账号'
                    },
                    {
                        id: 500,
                        link: '/manage/settlement',
                        name: '收益',
                        white: true
                    },
                    // {
                    //     id: 413,
                    //     link: '/manage/artistList',
                    //     name: '艺人信息',
                    // },
                    {
                        id: 399,
                        link: this.vip && this.vip.isContractSigned == 1 ? '/manage/contractdetails' : '',
                        name: '合同管理'
                    },
                    {
                        id: 410,
                        link: '/manage/invitation',
                        name: '邀请信息'
                    }
                ]
            };
            _permissions.push(_accountData);
            // _permissions.push({
            //     id: 4000,
            //     link: '/help',
            //     name: '帮助中心',
            // })
            return this.getMenus(this.menuList || _permissions);
        }
    },
    methods: {
        // 过滤菜单数据
        getMenus(menus) {
            const { whiteFlag } = this.$store.state;
            function getMenu(childs) {
                return childs.filter(menu => {
                    if (menu.child) menu.child = getMenu(menu.child);
                    if (menu.white) {
                        return whiteFlag ? true : false;
                    } else {
                        return true;
                    }
                });
            }
            return getMenu(menus);
        },
        /**
         * 数组转树形
         * @param {Array} data 需要整理的数组
         * @return {Array} 整理后的树形数据
         */
        treePermissions(data, format = {}) {
            const _rootId = format.rootId || 0;
            const _id = format.id || 'id';
            const _pid = format.parentId || 'pid';
            const _child = format.child || 'child';
            // 递归方法
            function getNode(id) {
                const node = [];
                for (let i = 0; i < data.length; i++) {
                    if (data[i][_pid] === id && data[i].type === 1) {
                        data[i][_child] = getNode(data[i][_id]);
                        node.push(data[i]);
                    }
                }
                if (node.length === 0) return [];
                return node;
            }
            // 使用根节点
            return getNode(_rootId);
        },
        //设置菜单选择项
        setMenuActive() {
            let path = '/';
            this.menus.forEach(menu => {
                const { child } = menu;
                if (child && child.length > 0) {
                    child.forEach(item => {
                        if (item.link && this.$route.path.match(new RegExp(item.link, 'g'))) {
                            path = item.link;
                        }
                    });
                } else {
                    if (menu.link && this.$route.path.match(new RegExp(menu.link, 'g'))) {
                        path = menu.link;
                    }
                }
            });
            return path;
        }
    }
};
</script>
<style lang="scss" scoped>
.page-sidebar {
    background: #fff;
    width: 300px;
    min-width: 300px;
    position: relative;
    z-index: 2;
    border-radius: 10px;

    .page-sidebar-box {
        .el-menu {
            margin-top: 40px;
            border: 0;
            margin-left: 30px;
            margin-right: 30px;

            .el-menu-item,
            ::v-deep .el-submenu__title {
                height: 50px;
                line-height: 50px;
                margin-bottom: 10px;
                border-radius: 4px;
                position: relative;

                &:hover {
                    background: $--color-black;
                    color: $-text-50;
                }
            }

            ::v-deep .el-submenu__icon-arrow {
                display: none;
            }

            .icon-tip {
                position: absolute;
                top: -10px;
                left: 85px;
                width: 68px;
                height: 38px;
                background: url(~@/assets/img/sidebar/icon-tip.png) center no-repeat;
                background-size: cover;
                color: #fff;
                line-height: 19px;
                font-size: 16px;
                text-align: center;
                line-height: 32px;
                font-weight: bold;
                transform: scale(0.5);
            }

            .nav-icon {
                display: inline-block;
                vertical-align: -2px;
                margin-right: 10px;
                width: 14px;
                height: 12px;
                background: url(~@/assets/img/sidebar/nav-icon.png) center center no-repeat;
                background-size: 100%;
            }

            .menu-icon {
                display: inline-block;
                vertical-align: -2px;
                margin-right: 10px;
                width: 12px;
                height: 14px;
                background: url(~@/assets/img/sidebar/menu-icon.png) center center no-repeat;
                background-size: 100%;
            }

            .point {
                position: absolute;
                width: 6px;
                height: 6px;
                background: #fb0000;
                border-radius: 50%;
                top: 8px;
                right: 90px;
            }

            .el-menu-item.is-active {
                background: $--color-black;
                color: $-text-50;

                .menu-icon {
                    background: url(~@/assets/img/sidebar/menu-icon-current.png) center center no-repeat;
                    background-size: 100%;
                }
            }
        }
    }
}
</style>
